import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Topics from "../pages/topics/page";
import OurApproach from "../pages/our-approach/page";
import UnderstandingGeneticHighCholesterol from "../pages/understanding-genetic-high-cholesterol/page";
import AtrialFibrillation from "../pages/atrial-fibrillation/page";
import ConsultationPage from "../pages/consultation/page";
import AuthPage from "../pages/auth/page";
import MyConsultationsPage from "../pages/my-consultations/page";
import ProfilePage from "../pages/profile/page";
import FamilialHeartDiseases from "../pages/familial-heart-diseases/page";
import FHSouthAsian from "../pages/fh-south-asian/page";
import HowToIdentifyFH from "../pages/how-to-identify-fh/page";
import WhatIsHeFH from "../pages/what-is-hefh/page";
import WhatIsHoFH from "../pages/what-is-hofh/page";
import HowIsFHTreated from "../pages/how-is-fh-treated/page";
import LipidGeneticTesting from "../pages/lipid-genetic-testing/page";
import CoronaryArteryDiseaseFH from "../pages/coronary-artery-disease-fh/page";
import AtherosclerosisVascularDiseaseFH from "../pages/atherosclerosis-vascular-disease-fh/page";
import StructuralValvularHeartDiseaseFH from "../pages/structural-valvular-heart-disease-fh/page";
import ComplicationsOutcomesFH from "../pages/complications-outcomes-fh/page";
import PregnancyFH from "../pages/pregnancy-fh/page";
import DiabetesInsulinResistanceFH from "../pages/diabetes-insulin-resistance-fh/page";
import HypertensionFH from "../pages/hypertension-fh/page";
import KidneyDiseaseFH from "../pages/kidney-disease-fh/page";
import MenopauseFH from "../pages/menopause-fh/page";
import StrokeFH from "../pages/stroke-fh/page";
import FHChildrenPage from "../pages/fh-children/page";
import FHFoodExercisePage from "../pages/fh-food-exercise/page";
import OurStory from "../pages/our-story/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/our-story",
    element: <OurStory />,
  },
  {
    path: "/topics",
    element: <Topics />,
  },
  {
    path: "/our-approach",
    element: <OurApproach />,
  },
  {
    path: "/understanding-genetic-high-cholesterol",
    element: <UnderstandingGeneticHighCholesterol />,
  },
  {
    path: "/atrial-fibrillation",
    element: <AtrialFibrillation />,
  },
  {
    path: "/consultation",
    element: <ConsultationPage />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/my-consultations",
    element: <MyConsultationsPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/familial-heart-diseases",
    element: <FamilialHeartDiseases />,
  },
  {
    path: "/fh-south-asian",
    element: <FHSouthAsian />,
  },
  {
    path: "/how-to-identify-fh",
    element: <HowToIdentifyFH />,
  },
  {
    path: "/what-is-hefh",
    element: <WhatIsHeFH />,
  },
  {
    path: "/what-is-hofh",
    element: <WhatIsHoFH />,
  },
  {
    path: "/how-is-fh-treated",
    element: <HowIsFHTreated />,
  },
  {
    path: "/lipid-genetic-testing",
    element: <LipidGeneticTesting />,
  },
  {
    path: "/coronary-artery-disease-fh",
    element: <CoronaryArteryDiseaseFH />,
  },
  {
    path: "/atherosclerosis-vascular-disease-fh",
    element: <AtherosclerosisVascularDiseaseFH />,
  },
  {
    path: "/structural-valvular-heart-disease-fh",
    element: <StructuralValvularHeartDiseaseFH />,
  },
  {
    path: "/complications-outcomes-fh",
    element: <ComplicationsOutcomesFH />,
  },
  {
    path: "/pregnancy-fh",
    element: <PregnancyFH />,
  },
  {
    path: "/diabetes-insulin-resistance-fh",
    element: <DiabetesInsulinResistanceFH />,
  },
  {
    path: "/hypertension-fh",
    element: <HypertensionFH />,
  },
  {
    path: "/kidney-disease-fh",
    element: <KidneyDiseaseFH />,
  },
  {
    path: "/menopause-fh",
    element: <MenopauseFH />,
  },
  {
    path: "/stroke-fh",
    element: <StrokeFH />,
  },
  {
    path: "/fh-children",
    element: <FHChildrenPage />,
  },
  {
    path: "/fh-food-exercise",
    element: <FHFoodExercisePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
